import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  addProcessRemark,
} from '@/api/gddlysjgtruehazardeventserv'

export default {
  state: {
    state_GdDlysjgTrueHazardEvent_GetAllResult: null,
    state_GdDlysjgTrueHazardEvent_SearchByNameResult: null,
    state_GdDlysjgTrueHazardEvent_GetPageResult: null,
    state_GdDlysjgTrueHazardEvent_GetDetailResult: null,
    state_GdDlysjgTrueHazardEvent_DeleteObjResult: null,
    state_GdDlysjgTrueHazardEvent_AddProcessRemarkResult: null,
  },
  mutations: {
    SET_GDDLYSJGTRUEHAZARDEVENT_GETALL_RESULT: (state, rst) => {
      state.state_GdDlysjgTrueHazardEvent_GetAllResult = rst;
    },
    SET_GDDLYSJGTRUEHAZARDEVENT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_GdDlysjgTrueHazardEvent_SearchByNameResult = rst;
    },
    SET_GDDLYSJGTRUEHAZARDEVENT_GETPAGE_RESULT: (state, rst) => {
      state.state_GdDlysjgTrueHazardEvent_GetPageResult = rst;
    },
    SET_GDDLYSJGTRUEHAZARDEVENT_GETDETAIL_RESULT: (state, rst) => {
      state.state_GdDlysjgTrueHazardEvent_GetDetailResult = rst;
    },
    SET_GDDLYSJGTRUEHAZARDEVENT_DELETEOBJ_RESULT: (state, rst) => {
      state.state_GdDlysjgTrueHazardEvent_DeleteObjResult = rst;
    },
    SET_GDDLYSJGTRUEHAZARDEVENT_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_GdDlysjgTrueHazardEvent_AddProcessRemarkResult = rst;
    },
  },
  actions: {
    GdDlysjgTrueHazardEventServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgTrueHazardEventServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgTrueHazardEventServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgTrueHazardEventServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgTrueHazardEventServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgTrueHazardEventServ_AddProcessRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_ADDPROCESSREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGTRUEHAZARDEVENT_ADDPROCESSREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GdDlysjgTrueHazardEvent_GetAllResult: state => {
      return state.state_GdDlysjgTrueHazardEvent_GetAllResult;
    },
    get_GdDlysjgTrueHazardEvent_SearchByNameResult: state => {
      return state.state_GdDlysjgTrueHazardEvent_SearchByNameResult;
    },
    get_GdDlysjgTrueHazardEvent_GetPageResult: state => {
      return state.state_GdDlysjgTrueHazardEvent_GetPageResult;
    },
    get_GdDlysjgTrueHazardEvent_GetDetailResult: state => {
      return state.state_GdDlysjgTrueHazardEvent_GetDetailResult;
    },
    get_GdDlysjgTrueHazardEvent_DeleteObjResult: state => {
      return state.state_GdDlysjgTrueHazardEvent_DeleteObjResult;
    },
    get_GdDlysjgTrueHazardEvent_AddProcessRemarkResult: state => {
      return state.state_GdDlysjgTrueHazardEvent_AddProcessRemarkResult;
    },
  }
}